import { render, staticRenderFns } from "./BusinessStatusModal.vue?vue&type=template&id=771c6570&scoped=true"
import script from "./BusinessStatusModal.vue?vue&type=script&lang=js"
export * from "./BusinessStatusModal.vue?vue&type=script&lang=js"
import style0 from "./BusinessStatusModal.vue?vue&type=style&index=0&id=771c6570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c6570",
  null
  
)

export default component.exports